// extracted by mini-css-extract-plugin
module.exports = {"primarydark":"#333333","section":"ProfileSection_section__3FUr3","header":"ProfileSection_header__2l7pF"};